export class BasicProperties {
    constructor() { }
}
